import { VideoSourceSettings } from "../../../../../components/VideoSourceSettings";
import { getGuideDisplayName } from "../../../../../shared/guideNames.js";
import React, { useState, useEffect } from "react";
import { clone, uuid } from "../../../../../shared/utils";
import {
  BTN_GHOST,
  BTN_PRIMARY,
  BUTTON_RESET,
  INPUT,
  LABEL,
} from "../../../../../styles";
import { GuiaEditor } from "../Guide";
import { fetchOlimpiadaAulaDetalhes } from "../../../../../services/olimpiadaConteudoApi";
export function LessonEditor(props) {
  let aula = props.aula;
  let onCancel = props.onCancel;
  let onSave = props.onSave;
  let showFlash = props.showFlash;
  let onBlockDeleted = props.onBlockDeleted;
  const [local, setLocal] = useState(() => clone(aula));
  const [guiaId, setGuiaId] = useState(aula.guias[0]?.id || null);
  const [guiaDragId, setGuiaDragId] = useState(null);
  const [guiaDragOverId, setGuiaDragOverId] = useState(null);
  const [loadingBlocos, setLoadingBlocos] = useState(true);
  useEffect(() => {
    let active = true;
    setLoadingBlocos(true);
    fetchOlimpiadaAulaDetalhes(aula.id)
      .then((detalhes) => {
        if (active && detalhes) {
          setLocal((prev) => ({
            ...prev,
            guias: Array.isArray(detalhes.guias) ? detalhes.guias : prev.guias,
          }));
          setGuiaId((prev) => {
            return prev || detalhes.guias?.[0]?.id || null;
          });
        }
      })
      .catch(() => {
        if (active) {
          showFlash("Erro ao carregar conteúdo da aula.", "er");
        }
      })
      .finally(() => {
        if (active) {
          setLoadingBlocos(false);
        }
      });
    return () => {
      active = false;
    };
  }, [aula.id]);
  const guiaAtual =
    local.guias.find((itemId) => itemId.id === guiaId) ||
    local.guias[0] ||
    null;
  const updateGuia = (resultado, nextGuia) => {
    setLocal((prev) => ({
      ...prev,
      guias: prev.guias.map((itemId) =>
        itemId.id === resultado ? nextGuia : itemId,
      ),
    }));
  };
  return (
    <div
      style={{
        display: "grid",
        gap: 14,
      }}
    >
      <div
        style={{
          display: "grid",
          gap: 12,
        }}
      >
        <div>
          <label style={LABEL}>{"Titulo da aula"}</label>
          <input
            value={local.titulo}
            onChange={(event) =>
              setLocal((prev) => ({
                ...prev,
                titulo: event.target.value,
              }))
            }
            style={INPUT}
          />
        </div>
        <div>
          <label style={LABEL}>{"URL do video"}</label>
          <input
            value={local.videoUrl || ""}
            onChange={(event) =>
              setLocal((prev) => ({
                ...prev,
                videoUrl: event.target.value,
              }))
            }
            style={INPUT}
            placeholder={"https://www.youtube.com/embed/..."}
          />
          <VideoSourceSettings src={local.videoUrl} />
        </div>
      </div>
      <div
        style={{
          padding: 14,
          borderRadius: 14,
          background: "#F8FBFC",
          border: "1px solid #E7EEF2",
        }}
      >
        {loadingBlocos ? (
          <div
            style={{
              padding: "24px 0",
              textAlign: "center",
              color: "#64748B",
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            {"Carregando conteúdo da aula…"}
          </div>
        ) : (
          <React.Fragment>
            <div
              style={{
                display: "flex",
                gap: 6,
                flexWrap: "wrap",
                marginBottom: 12,
              }}
            >
              {local.guias.map((guia) => (
                <div
                  draggable={true}
                  onDragStart={(event) => {
                    setGuiaDragId(guia.id);
                    event.dataTransfer.effectAllowed = "move";
                    event.dataTransfer.setData("text/plain", guia.id);
                  }}
                  onDragOver={(event) => {
                    event.preventDefault();
                    if (guiaDragOverId !== guia.id) {
                      setGuiaDragOverId(guia.id);
                    }
                  }}
                  onDrop={(event) => {
                    event.preventDefault();
                    ((origemId, destinoId) => {
                      if (origemId && destinoId && origemId !== destinoId) {
                        setLocal((prev) => {
                          const guias = [...(prev.guias || [])];
                          const origemIndex = guias.findIndex(
                            (itemId) => itemId.id === origemId,
                          );
                          const destinoIndex = guias.findIndex(
                            (itemId) => itemId.id === destinoId,
                          );
                          if (origemIndex < 0 || destinoIndex < 0) return prev;
                          const [guiaMovida] = guias.splice(origemIndex, 1);
                          guias.splice(destinoIndex, 0, guiaMovida);
                          return {
                            ...prev,
                            guias,
                          };
                        });
                      }
                    })(
                      guiaDragId || event.dataTransfer.getData("text/plain"),
                      guia.id,
                    );
                    setGuiaDragId(null);
                    setGuiaDragOverId(null);
                  }}
                  onDragEnd={() => {
                    setGuiaDragId(null);
                    setGuiaDragOverId(null);
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    opacity: guiaDragId === guia.id ? 0.6 : 1,
                    outline:
                      guiaDragOverId === guia.id && guiaDragId !== guia.id
                        ? "2px dashed #4FB3A9"
                        : "none",
                    borderRadius: 10,
                  }}
                  key={guia.id}
                >
                  <button
                    onClick={() => setGuiaId(guia.id)}
                    style={{
                      ...BUTTON_RESET,
                      background:
                        guiaAtual?.id === guia.id ? "#4FB3A9" : "#FFF",
                      color: guiaAtual?.id === guia.id ? "#FFF" : "#526273",
                      borderRadius: 10,
                      padding: "8px 12px",
                      fontSize: 12,
                      fontWeight: 800,
                      border: "1px solid #DCE6EB",
                      cursor: "grab",
                    }}
                  >
                    {getGuideDisplayName(guia.nome)}
                  </button>
                  {local.guias.length > 1 && (
                    <button
                      onClick={() => {
                        const nextGuias = local.guias.filter(
                          (itemId2) => itemId2.id !== guia.id,
                        );
                        setLocal((prev) => ({
                          ...prev,
                          guias: nextGuias,
                        }));
                        setGuiaId(nextGuias[0]?.id || null);
                      }}
                      style={{
                        ...BUTTON_RESET,
                        background: "transparent",
                        color: "#DC2626",
                        fontSize: 12,
                        fontWeight: 800,
                      }}
                    >
                      {"x"}
                    </button>
                  )}
                </div>
              ))}
              <button
                onClick={() => {
                  const novaGuia = {
                    id: uuid(),
                    nome: "Nova guia",
                    blocos: [],
                  };
                  setLocal((prev) => ({
                    ...prev,
                    guias: [...prev.guias, novaGuia],
                  }));
                  setGuiaId(novaGuia.id);
                }}
                style={BTN_GHOST}
              >
                {"+ Guia"}
              </button>
            </div>
            {guiaAtual && (
              <div
                style={{
                  display: "grid",
                  gap: 12,
                }}
              >
                <input
                  value={getGuideDisplayName(guiaAtual.nome)}
                  onChange={(event) =>
                    updateGuia(guiaAtual.id, {
                      ...guiaAtual,
                      nome: event.target.value,
                    })
                  }
                  style={INPUT}
                  placeholder={"Nome da guia"}
                />
                <GuiaEditor
                  guia={guiaAtual}
                  onChange={(nextGuia) => updateGuia(guiaAtual.id, nextGuia)}
                  showFlash={showFlash}
                  onBlockDeleted={onBlockDeleted}
                />
              </div>
            )}
          </React.Fragment>
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
        }}
      >
        <button onClick={onCancel} style={BTN_GHOST}>
          {"Cancelar"}
        </button>
        <button
          onClick={() => onSave(local)}
          style={BTN_PRIMARY}
          disabled={loadingBlocos}
        >
          {"Salvar aula"}
        </button>
      </div>
    </div>
  );
}
